import React, { useState, useEffect } from "react";
import axios from "axios";

import AddressForm from "../components/AddressForm";
import { useAppContext } from "../context/AppContext"; // your context hook
import SnackbarAlert from "../hooks/SnackbarAlert"; // ✅ default import




export default function HotelPage() {
  const { clientId } = useAppContext();
  const [addresses, setAddresses] = useState([]);

  // Fetch addresses on mount/clientId change
  useEffect(() => {
    if (!clientId) return;

    async function fetchAddresses() {
      try {
        const response = await axios.get(`/api/address?client_id=${clientId}`);
        setAddresses(response.data);
      } catch (err) {
        console.error("Failed to fetch addresses", err);
      }
    }

    fetchAddresses();
  }, [clientId]);

  // HotelPage.jsx

const handleAdd = async (newAddress) => {
  try {
    const payload = { ...newAddress, client_id: clientId };
    const response = await axios.post("/api/address", payload);
    setAddresses(prev => [...prev, response.data]);
    SnackbarAlert("Address added successfully!", "success");
  } catch (err) {
    console.error("Failed to add address", err);
    SnackbarAlert("Failed to add address", "error");
  }
};

const handleUpdate = async (updatedAddress) => {
  try {
    const payload = { ...updatedAddress, client_id: clientId };
    const response = await axios.put(`/api/address/${updatedAddress.id}`, payload);
    setAddresses(prev =>
      prev.map(addr => (addr.id === updatedAddress.id ? response.data : addr))
    );
    SnackbarAlert("Address updated successfully!", "success");
  } catch (err) {
    console.error("Failed to update address", err);
    SnackbarAlert("Failed to update address", "error");
  }
};


  // Delete address by id
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this address?")) return;
    try {
      await axios.delete(`/api/address/${id}`);
      setAddresses(prev => prev.filter(addr => addr.id !== id));
    } catch (err) {
      console.error("Failed to delete address", err);
    }
  };

  return (
    <AddressForm
      clientId={clientId}
      addresses={addresses}
      onAdd={handleAdd}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      defaultAddressType="hotel"
    />
  );
}
